import { MouseEvent } from 'react';
import Image from 'next/image';
import { sendCtaClickEvent } from '@/features/analytics/datalayer/datalayer';
import { AppNextLink } from '@/features/app-next-link';
import { cn } from '@/utils/cn';
import { useGetSearchboxBanner } from './utils/use-get-searchbox-banner';
interface Props {
  className?: string;
  handleClickItem: (e: MouseEvent, href: string) => void;
}
const SearchboxBanner = ({
  className,
  handleClickItem
}: Props) => {
  const {
    isLoading,
    data
  } = useGetSearchboxBanner();
  if (isLoading) return <div className={cn('aspect-[3] h-auto w-full animate-pulse rounded-md bg-gray-100 lg:aspect-[4.3]', className)} />;
  if (!data || !data.desktopImageUrl || !data.mobileImageUrl) return null;
  const handleClick = (event: MouseEvent) => {
    sendCtaClickEvent({
      elementIndex: 1,
      elementType: 'SearchBoxBanner',
      itemID: data.id?.toString() ?? '',
      ImageUrl: data.mobileImageUrl,
      destinationUrl: data.link ?? ''
    });
    handleClickItem(event, data.link ?? '');
  };
  return <AppNextLink href={data.link || ''} className={cn('relative flex aspect-[3] h-auto w-full lg:aspect-[4.3]', className)} onClick={e => handleClick(e)} data-sentry-element="AppNextLink" data-sentry-component="SearchboxBanner" data-sentry-source-file="searbhbox-banner.tsx">
            <picture data-sentry-element="picture" data-sentry-source-file="searbhbox-banner.tsx">
                <source media='(min-width: 1024px)' srcSet={data.desktopImageUrl} />
                <Image src={data.mobileImageUrl} alt={data.name || 'بنر سرچ باکس'} className='rounded-md object-contain' unoptimized fill data-sentry-element="Image" data-sentry-source-file="searbhbox-banner.tsx" />
            </picture>
        </AppNextLink>;
};
export default SearchboxBanner;